import {Pipe, PipeTransform} from '@angular/core';
import {CropTypeStore}       from '../../stores/base-data/crop.types.store';
import IFieldCropRotation = Data.FieldManagement.IFieldCropRotation;
import ICropTypes = Data.BaseData.ICropTypes;

@Pipe({
  name: 'allCrops'
})
export class AllCropsPipe implements PipeTransform {

  constructor(private croptypeStore: CropTypeStore) {
  }

  transform(value: IFieldCropRotation[], args?: number): ICropTypes[] {
    if (!value || !(args >= 0)) {
      return [];
    }
    const keys = value
      .FindAll(_ => !!_.Yields[args])
      .Convert(_ => _.Yields[args].MainCrop)
      .FindAll(_ => _ >= 0)
      .Unique<number>();
    return keys.Convert(i => this.croptypeStore.getDefaultCroptype(i));
  }

}
